import classNames from 'classnames';
import { useRef } from 'react';

interface TransformationProps {
  path: string;
  compress?: number;
  width: number;
  height?: number;
  sharpen?: boolean;
  faces?: boolean;
  entropy?: boolean;
}

export function build_responsive_url(props: TransformationProps, dpr = 1): string {
  const url = new URL(props.path.includes('https') ? props.path : `https://optimize.photology.co/${props.path}`);

  if(url.hostname === 'photology-tmp.0a2534794711331847973bf5cb58c948.r2.cloudflarestorage.com'){
    url.hostname = 'tmp.photology.co';
  }

  if(url.hostname === 'photology-uploads.0a2534794711331847973bf5cb58c948.r2.cloudflarestorage.com'){
    url.hostname = 'uploads.mls.tours';
  }

  if(url.pathname.includes('responsive/')){
    url.pathname = url.pathname.replace('1x', `${dpr}x`).replace('2x', `${dpr}x`).replace('3x', `${dpr}x`);

    return url.toString();
  }

  if(url.pathname.includes('.svg')){
    return url.toString();
  }

  const compress = props.compress || 90;

  url.searchParams.set('q', compress.toString());
  url.searchParams.set('auto', 'format,compress');
  url.searchParams.set('dpr', dpr.toString());
  url.searchParams.set('w', props.width.toString());

  if (props.height) {
    url.searchParams.set('h', props.height.toString());

    if (props.faces) {
      url.searchParams.set('fit', 'facearea');
      url.searchParams.set('crop', 'faces');
      url.searchParams.set('facepad', '2');
    } else {
      url.searchParams.set('fit', 'crop');

      if (props.entropy) {
        url.searchParams.set('crop', 'entropy');
      }
    }
  }

  if (props.sharpen) {
    url.searchParams.set('sharp', '50');
  }

  return url.toString();
}

export default function ResponsiveImage(
  props: {
    width?: number;
    className?: string;
    round?: boolean;
    onClick?: () => void;
  } & TransformationProps,
): JSX.Element {
  const ref = useRef<HTMLImageElement>(null);

  return (
    <img
      ref={ref}
      src={build_responsive_url(props, 1)}
      srcSet={`${build_responsive_url(props, 1)}, ${build_responsive_url(props, 2)} 2x, ${build_responsive_url(
        props,
        3,
      )} 3x`}
      width={props.width}
      onClick={props.onClick}
      className={classNames(props.className, { 'rounded-theme overflow-hidden': props.round })}
    />
  );
}
